import { IStack } from './stack.inteface';

export class Stack<T> implements IStack<T> {
  private readonly _storage: T[] = [];

  public push(item: T): void {
    this._storage.push(item);
  }

  public pop(): T | undefined {
    return this._storage.pop();
  }

  public size(): number {
    return this._storage.length;
  }
}
